<template>
    <a-modal :title="isChildAdd ? '新增子追问' : '新增追问'" v-model:open="open" @ok="handleOk" class="full-modal" :width="'50vw'"
        :body-style="{ maxHeight: '100vh', overflowY: 'auto' }">
        <div v-if="parentHistory.length > 0" class="form-item form-colspan-2">
            <a>追问链路：</a>
            <div class="parent-history">
                <div v-for="(item, index) in parentHistory" :key="item.id"
                    :class="['history-item', { 'history-item-current': index === 0 }]">
                    <span class="history-round">第{{ item.followRound }}轮</span>
                    <span class="history-arrow">→</span>
                    <span class="history-text" :title="item.followContent">{{ item.followContent }}</span>
                    <span v-if="index === 0" class="history-badge">当前父级</span>
                </div>
            </div>
        </div>
                <div class="form-grid">
            <div class="form-item form-colspan-2">
                <a><span class="startColor">*</span>问题关键词：</a>
                <a-textarea v-model:value="pushData.keyword" maxlength="2000" :rows="4" placeholder="请输入问题关键词" :disabled="isChildAdd" />
            </div>
            <div class="form-item form-colspan-2">
                <a><span class="startColor">*</span>追问内容：</a>
                <a-textarea v-model:value="pushData.followContent" maxlength="2000" :rows="4" placeholder="请输入追问内容" />
            </div>
            <div class="form-item">
                <a><span class="startColor">*</span>追问轮次：</a>
                <a-select v-model:value="pushData.followRound" placeholder="请选择追问轮次" disabled>
                    <a-select-option v-for="n in followRoundOptions" :key="n" :value="n">{{ n }}</a-select-option>
                </a-select>
            </div>
            <div class="form-item form-colspan-2">
                <a><span class="startColor">*</span>关联案例：</a>
                <div class="case-search-bar">
                    <a-input v-model:value="searchKeyword" placeholder="输入案例编号或名称搜索" @press-enter="handleCaseSearch" />
                    <a-button type="primary" @click="handleCaseSearch" :loading="caseSearching">
                        <template #icon><SearchOutlined /></template>
                        搜索
                    </a-button>
                </div>
                <div class="case-tags" v-if="selectedCases.length > 0">
                    <a-tag v-for="item in selectedCases" :key="item.caseNo" closable @close="removeSelected(item)">
                        {{ item.caseNo }}
                    </a-tag>
                </div>
                <a-table v-if="caseOptions.length > 0" :data-source="caseOptions" :columns="caseColumns" row-key="caseNo"
                    :pagination="false" size="small" class="case-result-table" :row-selection="{ selectedRowKeys: selectedKeys, onChange: onSelectChange }">
                </a-table>
            </div>
        </div>
        <template #footer>
            <a-button key="back" @click="toAddCancel">取消</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">提交</a-button>
        </template>
    </a-modal>
</template>
<script>
import { saveFollowQuestion, taxCasePage, getFollowQuestionParentList } from '@/api/service';
import { message } from 'ant-design-vue';
import { SearchOutlined } from '@ant-design/icons-vue';
import { ref, computed, watch } from 'vue';
export default {
    name: 'addFollowComponent',
    components: {
        SearchOutlined
    },
    setup() {
        const loading = ref(false);
        const pushData = ref({
            keyword: '',
            followRound: 1,
            followContent: '',
            caseNo: [],
            parentId: null
        });
        const open = ref(false);
        const isChildAdd = ref(false);
        const caseOptions = ref([]);
        const caseSearching = ref(false);
        const searchKeyword = ref('');
        const selectedCases = ref([]);
        const parentHistory = ref([]);

        const caseColumns = [
            { title: '案例编号', dataIndex: 'caseNo', key: 'caseNo', width: '40%' },
            { title: '案例名称', dataIndex: 'caseName', key: 'caseName', width: '60%' },
        ];

        const selectedKeys = computed(() => selectedCases.value.map(item => item.caseNo));

        const followRoundOptions = computed(() => {
            return isChildAdd.value ? [2, 3, 4, 5] : [1, 2, 3, 4, 5];
        });

        const resetForm = () => {
            pushData.value = {
                keyword: '',
                followRound: isChildAdd.value ? null : 1,
                followContent: '',
                caseNo: [],
                parentId: null
            };
            selectedCases.value = [];
            searchKeyword.value = '';
            caseOptions.value = [];
            parentHistory.value = [];
            isChildAdd.value = false;
        };

        const openForChild = async (parentId) => {
            resetForm();
            isChildAdd.value = true;
            pushData.value.parentId = parentId;
            pushData.value.followRound = null;
            open.value = true;
            const response = await getFollowQuestionParentList(parentId);
            if (response.code === 200 && response.data) {
                parentHistory.value = Array.isArray(response.data) ? response.data : [response.data];
                const parent = parentHistory.value[parentHistory.value.length - 1];
                if (parent) {
                    if (parent.keyword) {
                        pushData.value.keyword = parent.keyword;
                    }
                    pushData.value.followRound = (parent.followRound || 0) + 1;
                }
            }
        };

        const onSelectChange = (keys, rows) => {
            selectedCases.value = rows;
            pushData.value.caseNo = rows.map(item => item.caseNo);
        };

        const removeSelected = (item) => {
            selectedCases.value = selectedCases.value.filter(i => i.caseNo !== item.caseNo);
            pushData.value.caseNo = selectedCases.value.map(i => i.caseNo);
        };

        const handleCaseSearch = async () => {
            const keyword = searchKeyword.value.trim();
            caseSearching.value = true;
            const response = await taxCasePage({
                pageNumber: 1,
                pageSize: 5,
                keyword: keyword || undefined
            });
            if (response.code === 200) {
                caseOptions.value = (response.data.records || []).map(item => ({
                    caseNo: item.caseNo,
                    caseName: item.caseName
                }));
            }
            caseSearching.value = false;
        };

        const loadLatestCases = async () => {
            caseSearching.value = true;
            const response = await taxCasePage({
                pageNumber: 1,
                pageSize: 5
            });
            if (response.code === 200) {
                caseOptions.value = (response.data.records || []).map(item => ({
                    caseNo: item.caseNo,
                    caseName: item.caseName
                }));
            }
            caseSearching.value = false;
        };

        watch(open, (val) => {
            if (val) {
                if (!isChildAdd.value) {
                    resetForm();
                }
                loadLatestCases();
            }
        });

        const toAddCancel = () => {
            resetForm();
            open.value = false;
        };

        const handleOk = async () => {
            if (!pushData.value.keyword) {
                message.error('请填写问题关键词');
                return;
            }
            if (!pushData.value.followRound) {
                message.error('请选择追问轮次');
                return;
            }
            if (!pushData.value.followContent) {
                message.error('请填写追问内容');
                return;
            }
            if (!pushData.value.caseNo || pushData.value.caseNo.length === 0) {
                message.error('请选择关联案例');
                return;
            }
            const submitData = { ...pushData.value };
            if (Array.isArray(submitData.caseNo)) {
                submitData.caseNo = submitData.caseNo.join(',');
            }
            loading.value = true;
            const response = await saveFollowQuestion(submitData);
            if (response.code === 200) {
                message.success('添加成功');
                open.value = false;
            } else {
                message.error('添加失败' + response.msg);
            }
            loading.value = false;
        };

        return {
            loading,
            open,
            pushData,
            caseOptions,
            caseSearching,
            searchKeyword,
            selectedCases,
            parentHistory,
            caseColumns,
            selectedKeys,
            onSelectChange,
            removeSelected,
            handleCaseSearch,
            loadLatestCases,
            isChildAdd,
            followRoundOptions,
            openForChild,
            toAddCancel,
            handleOk,
            ref,
            SearchOutlined
        };
    }
}
</script>
<style>
.full-modal {
    top: 0;
}
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 16px;
}
.form-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.form-colspan-2 {
    grid-column: 1 / -1;
}
.form-item a,
.form-colspan-2 a {
    font-size: 14px;
    font-weight: 500;
}
.startColor {
    color: #ff4757;
}
.case-search-bar {
    display: flex;
    gap: 8px;
}
.case-search-bar .ant-input {
    flex: 1;
}
.case-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 4px 0;
}
.case-result-table {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
}
.case-result-table .ant-table {
    border: none;
}
.parent-history {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
    background: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 8px 12px;
}
.history-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 13px;
}
.history-item-current {
    background: #e6f7ff;
    border: 1px solid #91d5ff;
}
.history-round {
    color: #666;
    white-space: nowrap;
}
.history-arrow {
    color: #ccc;
}
.history-text {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333;
}
.history-badge {
    color: #1890ff;
    font-size: 12px;
    border: 1px solid #1890ff;
    border-radius: 2px;
    padding: 0 4px;
    margin-left: 4px;
}
</style>
